import type { IEditorConfig, IToolbarConfig } from '@wangeditor/editor';

export const defaultToolbarConfig: Partial<IToolbarConfig> = {
  excludeKeys: ['insertVideo', 'uploadImage', 'uploadVideo', 'fullScreen'],
};

export const defaultEditorConfig: Partial<IEditorConfig> = {
  placeholder: '请输入…',
  maxLength: 200,
};
